export enum PlatformModel {
  DOZI = 'dozi',
  ZI = 'zi',
  DO = 'do',
  ZI_LITE = 'zi lite',
  RECRUITER = 'recruiter',
  MARKETING_CLOUD = 'marketing_cloud',
  ZI_CHAT = 'zi chat',
  ENGAGE = 'engage',
  ADMIN = 'admin',
  COMMUNITY = 'community',
  ESSENTIALS = 'essentials',
  DATA_PLATFORM = 'data platform',
  TAM = 'tam',
  OPERATIONS = 'operationsos',
  AAT = 'gtm studio',
  DEV_PORTAL = 'dev portal',
  GTM_STUDIO = 'gtm admin',
  GTM_COPILOT = 'gtm copilot',
  CHORUS = 'chorus',
  STUDIO = 'studio',
  STUDIOV2 = 'studiov2',
  TALENT_AUTOPILOT = 'talent autopilot'
}
